// Pure formatting helpers — no side effects, no React.

export function formatNumber(value) {
  return new Intl.NumberFormat("es-AR").format(Number(value || 0));
}

export function formatDate(value) {
  if (!value) return "Sin timestamp";
  try {
    return new Intl.DateTimeFormat("es-AR", { dateStyle: "short", timeStyle: "medium" }).format(new Date(value));
  } catch (error) {
    return String(value);
  }
}

export function riskClass(level) {
  if (level === "critical") return "risk-critical";
  if (level === "high") return "risk-high";
  if (level === "medium") return "risk-medium";
  if (level === "low") return "risk-low";
  return "risk-info";
}

export function riskLevelFromScore(score = 0) {
  if (score >= 85) return "critical";
  if (score >= 70) return "high";
  if (score >= 55) return "medium";
  if (score >= 35) return "low";
  return "info";
}

export function formatRelativeSeconds(seconds) {
  if (seconds === null || seconds === undefined) return "—";
  const s = Math.round(Number(seconds));
  if (Number.isNaN(s)) return "—";
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.round(s / 60)}min`;
  if (s < 86400) return `${(s / 3600).toFixed(1)}h`;
  return `${(s / 86400).toFixed(1)}d`;
}
